import styled, { css } from "styled-components";

export default styled.div`
  ${props =>
    css`
      ${props.styles}
    `};
`;
